
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-237 360.9 120 120"}},[_c('path',{attrs:{"d":"M-144.1 467.7v-31h10.3V478h-92.9v-41.3h10.3v31h72.3z"}}),_c('path',{attrs:{"d":"M-205 433.7l50.5 10.6 2.1-10.2-50.5-10.6-2.1 10.2zm6.6-24l46.8 21.8 4.3-9.4-46.8-21.9-4.3 9.5zm13-23l39.7 33 6.5-7.9-39.7-33-6.5 7.9zm25.7-24.5l-8.3 6.1 30.7 41.4 8.3-6.1-30.7-41.4zm-46.4 95h51.6V447h-51.6v10.2z"}})])
      }
    
      }
    